var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "xd-phone-input",
      class: {
        "is-focus": _vm.isFocused,
        "is-error": _vm.hasError,
        "is-disabled": _vm.disabled,
      },
    },
    [
      _c(
        "el-popover",
        {
          ref: "popover",
          attrs: {
            placement: "bottom-start",
            width: "320",
            trigger: "click",
            disabled: _vm.disabled,
            "popper-class": "xd-phone-popover",
          },
          on: { show: _vm.onPopoverShow },
        },
        [
          _c("div", { staticClass: "xpi-popover" }, [
            _c("div", { staticClass: "xpi-search" }, [
              _c("i", { staticClass: "el-icon-search" }),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.searchKeyword,
                    expression: "searchKeyword",
                  },
                ],
                ref: "searchInput",
                staticClass: "xpi-search-input",
                attrs: { type: "text", placeholder: "搜索国家/地区/区号" },
                domProps: { value: _vm.searchKeyword },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.searchKeyword = $event.target.value
                  },
                },
              }),
              _vm._v(" "),
              _vm.searchKeyword
                ? _c("i", {
                    staticClass: "el-icon-circle-close xpi-search-clear",
                    on: {
                      click: function ($event) {
                        _vm.searchKeyword = ""
                      },
                    },
                  })
                : _vm._e(),
            ]),
            _vm._v(" "),
            _vm.customCodeFromKeyword
              ? _c(
                  "div",
                  {
                    staticClass: "xpi-custom",
                    on: { click: _vm.useCustomCode },
                  },
                  [
                    _c("div", { staticClass: "xpi-custom-icon" }, [
                      _c("i", { staticClass: "el-icon-plus" }),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "xpi-custom-info" }, [
                      _c("div", { staticClass: "xpi-custom-title" }, [
                        _vm._v(
                          "使用自定义区号「" +
                            _vm._s(_vm.customCodeFromKeyword) +
                            "」"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "xpi-custom-sub" }, [
                        _vm._v("列表中未匹配？直接使用此区号"),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("i", { staticClass: "el-icon-check" }),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "xpi-list" },
              [
                _vm._l(_vm.filteredCountries, function (country, idx) {
                  return _c(
                    "div",
                    {
                      key: country.iso2 || "cu-" + idx,
                      staticClass: "xpi-list-item",
                      class: { selected: _vm.isSelected(country) },
                      on: {
                        click: function ($event) {
                          return _vm.selectCountry(country)
                        },
                      },
                    },
                    [
                      country.icon
                        ? _c("img", {
                            staticClass: "xpi-flag",
                            attrs: { src: country.icon },
                          })
                        : _c(
                            "div",
                            { staticClass: "xpi-flag xpi-flag-fallback" },
                            [
                              _c("i", {
                                staticClass: "el-icon-location-information",
                              }),
                            ]
                          ),
                      _vm._v(" "),
                      _c("span", { staticClass: "xpi-name" }, [
                        _vm._v(_vm._s(country.name)),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "xpi-code" }, [
                        _vm._v(_vm._s(country.code)),
                      ]),
                      _vm._v(" "),
                      _vm.isSelected(country)
                        ? _c("i", { staticClass: "el-icon-check xpi-check" })
                        : _vm._e(),
                    ]
                  )
                }),
                _vm._v(" "),
                _vm.filteredCountries.length === 0 && !_vm.customCodeFromKeyword
                  ? _c("div", { staticClass: "xpi-empty" }, [
                      _vm._v(
                        "\n\t\t\t\t\t未找到匹配，输入「+数字」可使用自定义区号\n\t\t\t\t"
                      ),
                    ])
                  : _vm._e(),
              ],
              2
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "xpi-selector",
              attrs: { slot: "reference" },
              slot: "reference",
            },
            [
              _vm.selectedCountry.icon
                ? _c("img", {
                    staticClass: "xpi-flag",
                    attrs: { src: _vm.selectedCountry.icon },
                  })
                : _c("div", { staticClass: "xpi-flag xpi-flag-fallback" }, [
                    _c("i", { staticClass: "el-icon-location-information" }),
                  ]),
              _vm._v(" "),
              _c("span", { staticClass: "xpi-selector-code" }, [
                _vm._v(_vm._s(_vm.selectedCountry.code || "+86")),
              ]),
              _vm._v(" "),
              _c("i", { staticClass: "el-icon-arrow-down xpi-arrow" }),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "xpi-divider" }),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.phoneNumber,
            expression: "phoneNumber",
          },
        ],
        staticClass: "xpi-input",
        attrs: {
          type: "text",
          placeholder: _vm.selectedCountry.placeholder || "请输入手机号码",
          maxlength: (_vm.selectedCountry.maxLength || 15) + 4,
          disabled: _vm.disabled,
        },
        domProps: { value: _vm.phoneNumber },
        on: {
          input: [
            function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.phoneNumber = $event.target.value
            },
            _vm.onPhoneInput,
          ],
          focus: function ($event) {
            _vm.isFocused = true
          },
          blur: function ($event) {
            _vm.isFocused = false
            _vm.validatePhone()
          },
        },
      }),
      _vm._v(" "),
      _vm.phoneNumber && !_vm.disabled
        ? _c("i", {
            staticClass: "el-icon-circle-close xpi-clear",
            on: { click: _vm.clearPhone },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }